/********************************
 * FACEBOOK PIXEL EVENTS TRACKERS
 *******************************/
export function FbPixelTrackAddToCartEvent() {

    // Check if the fbq object is available
    if (window.fbq) {
      // Now you can use fbq object
      // Facebook Pixel, Meta Pixel Event Tracker
      window.fbq('track', 'AddToCart');

      console.log('AdToCart Event Fired');
    } else {
        // Handle the case where the fbq object is not available yet
        console.warn('Facebook Pixel not yet loaded.');
    }
}
  
export function FbPixelTrackInitiateCheckoutEvent() {
  
    // Check if the fbq object is available
    if (window.fbq) {
      // Now you can use fbq object
      // Facebook Pixel, Meta Pixel Event Tracker
      window.fbq('track', 'InitiateCheckout');

      console.log("InitiateCheckout Event Fired")  
    } else {
        // Handle the case where the fbq object is not available yet
        console.warn('Facebook Pixel not yet loaded.');
    }
}

export function FbPixelTrackPurchaseEvent(value, currency, contents = []) {
  
    console.log("amount is:", value)
    console.log("currency is:", currency)
    // Check if the fbq object is available
    if (window.fbq) {
      // Now you can use fbq object
      // Facebook Pixel, Meta Pixel Event Tracker
      window.fbq('track', 'Purchase',
        {
            value: Number(value),
            currency: currency,
        }
      );

      /*
            fbq('track', 'Purchase',
                // begin parameter object data
                {
                    value: 115.00,
                    currency: 'USD',
                    contents: [
                    {
                        id: '301',
                        quantity: 1
                    },
                    {
                        id: '401',
                        quantity: 2
                    }],
                    content_type: 'product'
                }
                // end parameter object data
            );


      */
       console.log('Purchase Event From "Manual Payment Approval" Fired')
    } else {
        // Handle the case where the fbq object is not available yet
        console.warn('Facebook Pixel not yet loaded.');
    }
}
  